import React, { useEffect } from 'react'
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'react-feather';

// Import Assets
import Multilingual from '../assets/images/organic-offering-multilingual.jpg';
import Motivate from '../assets/images/organic-offering-motivate.jpg';
import Mobilise from '../assets/images/organic-offering-mobilise.jpg';
import Foghorn from '../assets/images/organic-offering-foghorn.jpg';
import Magnify from '../assets/images/organic-offering-magnify.jpg';

const Services = (props) => {

  // Adding custom class to body 
  useEffect(() => {
    props.location.pathname === '/' ? document.body.classList.add("home-class") : document.body.classList.add("custom-class");

    // Clear hamburger menu
    document.body.classList.remove("menu-closed");
    document.body.classList.remove("menu-opened");
  })

  return (
    <React.Fragment>
      <div id="services-page">
        <div className="services-page pt-24">
          <div className="services-hero">
            
            <div className='breadcrumbs'>
              <li><Link to='/'>Home</Link> <span>{'>'}</span> <Link to='/services' className='current'>Services</Link></li>
            </div>

            <h4 className='heading3'>Services</h4>
            <p>A range of offerings leveraging digital tools to serve business needs.</p>
            
            <img src='https://organic-by-msl.s3.amazonaws.com/website/service-banner.jpg' alt="Services Main" />
            
          </div>

          <div className="services-container">
            <h1 className="heading3">What we offer</h1>

            <div className="services-wrapper service-wrapper-1">
              <div className="service-image">
                <img src={Multilingual} alt="Service 1" />
              </div>

              <div className="services-data">
                <h2 className="heading5">Multi-lingual Social Media and Digital Communications</h2>
                <p className="paragraph">Partners, customers, talent, or policymakers.</p>
                <Link to="/contact-us?offering=Multi-lingual Social Media and Digital Communications&cta=Send us a Brief" className="cta service-cta">Send us a Brief<ArrowUpRight /></Link>
              </div>
            </div>

            <div className="services-wrapper service-wrapper-2">
              <div className="services-data">
                <h2 className="heading5">Mobilise</h2>
                <p>Digital Communications for Social impact organisations.</p>
                <Link to="/contact-us?offering=Mobilise&cta=Let's Make a Difference" className="cta service-cta">Let's Make a Difference<ArrowUpRight /></Link>
              </div>

              <div className="service-image">
                <img src={Mobilise} alt="Service 2" />
              </div>
            </div>

            <div className="services-wrapper service-wrapper-3">
              <div className="service-image">
                <img src={Foghorn} alt="Service 3" />
              </div>

              <div className="services-data">
                <h2 className="heading5">Foghorn</h2>
                <p>Executive communications for the connected age. </p>
                <Link to="/contact-us?offering=Foghorn&cta=Nurture Inspired Leadership" className="cta service-cta">Nurture Inspired Leadership<ArrowUpRight /></Link>
              </div>
            </div>

            <div className="services-wrapper service-wrapper-2">
              <div className="services-data">
                <h2 className="heading5">Motivate</h2>
                <p>All things talent, current or prospective. </p>
                <Link to="/contact-us?offering=Motivate&cta=Create Engaged Workforces" className="cta service-cta">Create Engaged Workforces<ArrowUpRight /></Link>
              </div>

              <div className="service-image">
                <img src={Motivate} alt="Service 3" />
              </div>
            </div>

            <div className="services-wrapper service-wrapper-3">
              <div className="service-image">
                <img src={Magnify} alt="Service 2" />
              </div>
              
              <div className="services-data">
                <h2 className="heading5">Magnify</h2>
                <p>Mining conversations for communications gold. </p>
                <Link to="/contact-us?offering=Magnify&cta=Let's Begin Listening" className="cta service-cta">Let's Begin Listening<ArrowUpRight /></Link>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Footer CTA Ribbon */}
      <section id='take-next-leap' key='about'>
        <div className='take-next-leap'>
          <div className='take-next-leap__left'>
            <h1 className="heading4 black">We're willing to go beyond <span>for impactful communication</span></h1>
          </div>
          <div className='take-next-leap__right'>
            <p><Link to='/contact-us'>Talk to us today!<ArrowUpRight /></Link></p>
          </div>
        </div>
      </section>
      {/* Footer CTA Ribbon */}

    </React.Fragment>
  )
}

export default Services
